import { Injectable } from '@angular/core';
import { FormResponseSearchDto } from 'src/app/forms/shared/model/form-response-search.dto';
import { FormSearch } from 'src/app/forms/shared/model/form-search.model';
import { FormTemplate } from 'src/app/forms/shared/model/form-template.model';
import { SocialMediaType } from 'src/app/profiles/shared/social-media-type';
import { ApiCacheOptions, ApiService, PagedResultGeneric } from 'src/app/shared';
import { FormBuilderDto } from '../dto/form-builder.dto';
import { FormResponseDto } from '../dto/form-response.dto';

@Injectable({
  providedIn: 'root',
})
export class FormBuilderService {
  public constructor(private _apiService: ApiService) {}

  saveForm(formBuilder: FormBuilderDto): Promise<number> {
    var url = `Forms/V2/FormBuilder`;
    return this._apiService.post(url, formBuilder);
  }

  get(id: number): Promise<FormBuilderDto> {
    var url = `Forms/V2/FormBuilder/${id}`;
    return this._apiService.get(url);
  }

  delete(id: number) {
    var url = `Forms/V2/FormBuilder/${id}`;
    return this._apiService.delete(url);
  }

  toggleInactive(id: number, inactive: boolean) {
    var url = `Forms/V2/FormBuilder/${id}`;
    return this._apiService.put(url, inactive);
  }

  searchForms(params: FormSearch): Promise<PagedResultGeneric<FormTemplate>> {
    let cacheOptions = new ApiCacheOptions();
    cacheOptions.DisableCaching = true;
    return this._apiService.getPaged('Forms/Templates/', params, cacheOptions);
  }

  getActiveSocialMediaTypes(): Promise<PagedResultGeneric<SocialMediaType>> {
    return this._apiService.get('/Profiles/SocialMediaTypes?Active=true');
  }

  getSocialMediaType(id: number): Promise<SocialMediaType> {
    return this._apiService.get(`Profiles/SocialMedia/${id}`);
  }
}
